export const getMutationErrorMessage = (
  error: unknown,
  fallback: string,
): string => {
  if (!error || typeof error !== 'object' || !('data' in error)) {
    return fallback;
  }

  const { data } = error as { data?: unknown };
  if (typeof data === 'string' && data.trim()) {
    return data.trim();
  }

  if (!data || typeof data !== 'object') {
    return fallback;
  }

  if ('error' in data) {
    const message = (data as { error?: unknown }).error;
    if (typeof message === 'string' && message.trim()) {
      return message.trim();
    }
  }

  if ('errors' in data) {
    const errors = (data as { errors?: unknown }).errors;
    if (errors && typeof errors === 'object') {
      const messages: string[] = [];
      Object.values(errors as Record<string, unknown>).forEach((value) => {
        if (Array.isArray(value)) {
          value.forEach((item) => {
            if (typeof item === 'string' && item.trim()) messages.push(item.trim());
          });
        } else if (typeof value === 'string' && value.trim()) {
          messages.push(value.trim());
        }
      });
      if (messages.length) return messages.join('\n');
    }
  }

  return fallback;
};
